export default "__VITE_ASSET__BaaNHx7V__"